export default function initParallax() {
  const items = [...document.querySelectorAll('[class*="parallax-"]')].map(el => {
    const cls = [...el.classList].find(c => /^parallax-[xy]--?\d+$/.test(c))
    if (!cls) return null
    const [, axis, val] = cls.match(/^parallax-([xy])-(-?\d+)$/)
    return { el, axis, value: parseInt(val) }
  }).filter(Boolean)

  if (!items.length) return

  function tick() {
    const isDesktop = window.innerWidth >= 992
    items.forEach(({ el, axis, value }) => {
      if (!isDesktop) {
        el.style.transform = ''
        return
      }
      const rect = el.getBoundingClientRect()
      const progress = (window.innerHeight / 2 - (rect.top + rect.height / 2)) / window.innerHeight
      const translate = progress * value
      el.style.transform = axis === 'x'
        ? `translateX(${translate}px)`
        : `translateY(${translate}px)`
    })
    requestAnimationFrame(tick)
  }

  requestAnimationFrame(tick)
}
